import { PostQueueComment } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePostQueueComment extends BaseHttpService<PostQueueComment.Model> implements PostQueueComment {
  async post(body: PostQueueComment.Body): Promise<PostQueueComment.Model> {
    return await this.request('post', body);
  }
}
